
export default class HeroDownArrow {
    constructor(element) {
        this.passedElement = element;
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        this.arrow = this.passedElement;
        this.arrowTarget = document.querySelector('.hero-video');
    }

    handleClick = () => {
        this.arrowTarget.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    addEventListeners = () => {
        this.arrow.addEventListener('click', this.handleClick);
    }


    removeEventListeners = () => {
        this.arrow.removeEventListener('click', this.handleClick);
    }

    dismantle = () => {
        this.removeEventListeners();
        this.passedElement = null;
        this.initialised = false;
    }

}
